/* global axios */
import ApiClient from './ApiClient';

class CSATReportsAPI extends ApiClient {
  constructor() {
    super('csat_survey_responses', { accountScoped: true });
  }

  get({ page, from, to, user_ids, inbox_id, team_id, rating, is_problem_solved, ranking_csat} = {}) {
    return axios.get(this.url, {
      params: {
        page,
        since: from,
        until: to,
        sort: '-created_at',
        user_ids,
        inbox_id,
        team_id,
        rating,
        is_problem_solved,
        ranking_csat
      },
    });
  }

  download({ from, to, user_ids, inbox_id, team_id, rating, is_problem_solved, fileName } = {}) {
    return axios.get(`${this.url}/download`, {
      params: {
        since: from,
        until: to,
        sort: '-created_at',
        user_ids,
        inbox_id,
        team_id,
        rating,
        is_problem_solved,
        fileName
      },
    });
  }

  getMetrics({ from, to, user_ids, inbox_id, team_id, rating, is_problem_solved, ranking_csat } = {}) {
    // no ratings for metrics
    return axios.get(`${this.url}/metrics`, {
      params: { since: from, until: to, user_ids, inbox_id, team_id, rating, is_problem_solved, ranking_csat },
    });
  }

  refreshMetrics({ from, to, user_ids, inbox_id, team_id, rating, is_problem_solved } = {}) {
    return axios.post(`${this.url}/refresh_metrics`, null, {
      params: { since: from, until: to, user_ids, inbox_id, team_id, rating, is_problem_solved },
    });
  }

  getRefreshStatus({ from, to, user_ids, inbox_id, team_id, rating, is_problem_solved } = {}) {
    return axios.get(`${this.url}/refresh_status`, {
      params: { since: from, until: to, user_ids, inbox_id, team_id, rating, is_problem_solved },
    });
  }
}

export default new CSATReportsAPI();
